if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    document.querySelector('body').classList.add('safari')
}
var lastScrollTop = 0;

window.addEventListener("scroll", function(){
   let sliders = document.querySelectorAll('.recommendation-drawer-slider')
   var st = window.pageYOffset || document.documentElement.scrollTop;
   if (st > lastScrollTop){
      sliders.forEach(slider => {
        slider.classList.add('downhill')
        slider.classList.remove('uphill')
      });
   } else {
      sliders.forEach(slider => {
        slider.classList.remove('downhill')
        slider.classList.add('uphill')
      });
   }
   lastScrollTop = st <= 0 ? 0 : st;
}, false);
